import { makeStyles, withStyles } from "@material-ui/core/styles";
import { LinearProgress } from "@material-ui/core";
export const useStyles = makeStyles((theme) => ({
  container: {
    backgroundColor: "#fff",
    padding: 10,
    margin: 10,
  },
  top: {
    display: "flex",
    position: "relative",
    justifyContent: "center",
  },
  img: {
    width: "100%",
    maxWidth: 105,
    height: "100%",
    maxHeight: 230,
  },
  points: {
    position: "absolute",
    top: 5,
    left: 5,
  },
  ptext: {
    position: "absolute",
    top: 17,
    left: 17,
  },
  vs: {
    position: "absolute",
    top: 5,
    right: 5,
    backgroundColor: "#000",
    padding: 10,
    width: 60,
    borderTopRightRadius: 20,
    borderTopLeftRadius: 20,
    borderBottomLeftRadius: 20,
  },
  price: {
    position: "absolute",
    bottom: 10,
    right: -50,
    backgroundColor: "#000",
    padding: 4,
  },
  heading: {
    textAlign: "left",
    color: "#777",
    fontSize: 14,
    marginBottom: 2,
  },
  bar: {
    backgroundColor: "red",
  },
  detail: {
    marginTop: 10,
  },
}));
export const MyLinearProgress = withStyles((theme) => ({
  root: {
    height: 7,
    borderRadius: 3,
    marginBottom: 7,
  },
  colorPrimary: {
    backgroundColor:
      theme.palette.grey[theme.palette.type === "light" ? 200 : 700],
  },
  barColorPrimary: {
    background: "linear-gradient(90deg, #F59D63 30%, #FBE465 90%, #B8DA65 60%)",
    borderRadius: 3,
  },
}))(LinearProgress);
